// libs
import React from 'react';
import PropTypes from 'prop-types';

// component
import Radio from '../../../../forms/fields/radio/Radio';

function SearchCategories(props, { t }) {
  const { updateActiveType, reset } = props;
  const categories = ['activity', 'artwork', 'resource', 'all'];
  return (
    <div>
      <div className="filter__radio filter__contentType">
        <span className="field__label">{t('search.labels.contentType')}</span>
        {categories.map((category) =>
          <Radio
            name="filterCategory"
            component="input"
            value={category}
            label={t(`search.labels.${category}`)}
            type="radio"
            key={category}
            onChange={(e) => {
              updateActiveType(e.target.value);
              reset();
            }}
          />,
        )}
      </div>
    </div>
  );
}

SearchCategories.contextTypes = {
  t: PropTypes.func,
};

SearchCategories.propTypes = {
  reset: PropTypes.func.isRequired,
  updateActiveType: PropTypes.func.isRequired,
};

export default SearchCategories;



// WEBPACK FOOTER //
// ./src/app/components/pages/search/form/parts/SearchCategories.js